module.exports = __webpack_public_path__ + "static/media/vivacite.db185fb7.png";